export const AppRoute = {
  Default: "*",
  Carte: "/carte/:name",
};
